import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

const SessionManager = () => {
  const { user, logout } = useAuth();

  useEffect(() => {
    if (!user) return;

    // Vérifier l'expiration de la session toutes les minutes
    const checkSessionExpiry = () => {
      const lastActivity = localStorage.getItem('lastActivity');
      if (lastActivity) {
        const now = new Date().getTime();
        const lastActivityTime = parseInt(lastActivity);
        const sessionTimeout = 30 * 60 * 1000; // 30 minutes en millisecondes
        
        if (now - lastActivityTime > sessionTimeout) {
          toast.error('Votre session a expiré. Veuillez vous reconnecter.');
          logout();
        }
      }
    };

    // Mettre à jour l'activité utilisateur
    const updateLastActivity = () => {
      localStorage.setItem('lastActivity', new Date().getTime().toString());
    };

    // Événements pour détecter l'activité utilisateur
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    
    events.forEach(event => {
      document.addEventListener(event, updateLastActivity, true);
    });

    // Vérifier l'expiration toutes les minutes
    const interval = setInterval(checkSessionExpiry, 60000);

    // Vérifier immédiatement
    checkSessionExpiry();

    return () => {
      events.forEach(event => {
        document.removeEventListener(event, updateLastActivity, true);
      });
      clearInterval(interval);
    };
  }, [user, logout]);

  return null; // Ce composant ne rend rien
};

export default SessionManager;
